module.exports = __webpack_public_path__ + "static/media/broadband.e10e2fbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/broadband.svg
// module id = 464
// module chunks = 0